import React from "react";
import { MembershipPlan } from "./Membership/MembershipPlan";
import { MembershipPlanTwo } from "./Membership/MembershipPlanTwo";

export const MemberShip = () => {
  return (
    <view>
      <MembershipPlan />
      <MembershipPlanTwo />
    </view>
  );
};
